<template>
  <v-container class="d-flex flex-column">
    <div class="form align-self-center">
      <h3 class="primary--black">Date: <span class="primary--primary">September 10th 2022</span> </h3>
      <h3 class="primary--black">Time: <span class="primary--primary">10:30am - 2:00pm</span> </h3>

      <form v-on:submit.prevent="register()">
        <h2 class="text-h5 font-weight-bold">
          <span class="primary--text">Register</span> for our first <span class="primary--text">Webinar</span>
        </h2>
        <div class="mt-5">
          <v-progress-linear v-if="loading" indeterminate />
          <v-text-field
            v-model="email"
            filled
            :error-messages="emailErrors"
            data-testid="v-text-field"
            label="Email"
            @input="emailOnChange()"
          />
          <v-select
            v-model.trim="accountType"
            :error-messages="accountTypeMessages"
            filled
            :items="accountTypes"
            label="What do you do ?"
            class="accountType my-1 py-0"
            data-test="accountType"
            mx-20
            required
            @blur="$v.accountType.$touch()"
            @input="$v.accountType.$touch()"
          />
          <vue-tel-input-vuetify
            v-model="phone"
            :label="$t('auth.forms.labels.phone')"
            class="px-0 py-0"
            clearable
            data-testid="phone"
            :default-country="selectedCountry"
            :error-messages="phoneErrors"
            placeholder=""
            validate-on-blur
            @validate="setPhone"
            filled
          >
          </vue-tel-input-vuetify>
          <v-row class="ml-1">
            <v-col
              class="d-flex flex-row justify-space-between mx-0 my-0 px-0 py-0"
            >
              <v-btn
                :disabled="$v.$invalid || loading"
                class="btn-text"
                color="primary"
                data-testid="login-btn"
                type="submit"
                block
              >
                Register
                <v-icon> mdi-arrow_right_alt</v-icon>
              </v-btn>
             
            </v-col>
          </v-row>

          <v-row class="ml-1">
            <v-col class="d-flex flex-row justify-space-between mx-0 my-0 px-0 py-0 mt-3">

              <v-btn
                class="animate__animated animate__shakeX"
                color="primary"
                data-testid="login-btn"
                outlined
                @click="handleAddToCalender()"
                block
              >
                Add To Calender
                <v-icon right dark> mdi-arrow_right_alt</v-icon>
              </v-btn>
            </v-col>
            
          </v-row>
          <v-row class="ml-1">
            <v-col class="d-flex flex-row justify-space-between mx-0 my-0 px-0 py-0 mt-3">

              <v-btn
                class="white--text animate__animated animate__shakeY"
                color="red"
                data-testid="login-btn"
                filled
                href="https://www.youtube.com/watch?v=kyiM6ZNQRWI"
                target="_blank"
                block
              >
                Watch us on youtube
                <v-icon right> mdi-youtube</v-icon>
              </v-btn>
            </v-col>
            
          </v-row>
          
        </div>
        
      </form>
    </div>
  </v-container>
</template>

<script>
import linkedin from "@/assets/linkedin.png";
import twitter from "@/assets/twitter.png";
import Logo from "@/assets/guiomentorLogo.png";
import { email, minLength, required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      Logo,
      linkedin,
      twitter,
      email: "",
      showAddToCalender: false,
      showPassword: false,
      phone: null,
      loading: false,
      accountTypes: ["STUDENT", "MENTOR", "PARENT"],
      selectedCountry: 'UG',
      accountType: "",
      routeOnLogin: "/home",
      description:
        "Guiomentor is a platform directed to a niche of 10 to 25 years old. Its objective is to help students to choose the best career or discipline for them according to their skills and part of interest ",
      phoneErrors: [],
    };
  },
  metaInfo() {
    return {
      title: "Guiomentor - Webinar Registration",
      url: window.location.href,
      meta: [
        { name: "title", content: "Guiomentor - Webinar Registration" },
        {
          name: "description",
          content: this.description,
        },
        //Facebook
        { name: "og:type", content: "Website" },
        { name: "og:title", content: "Guiomentor - Log In" },
        { name: "og:description", content: this.description },
        { name: "og:image", content: this.Logo },

        // Twitter
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:url", content: window.location.href },
        { name: "twitter:title", content: "Guiomentor - Log In" },
        { name: "twitter:description", content: this.description },
        { name: "twitter:image", content: this.Logo },
      ],
    };
  },
  methods: {
    emailOnChange() {
      this.$v.email.$touch();
      this.emailTaken = false;
    },
    setPhone({ isValid, number }) {
      if (isValid) {
        this.phoneErrors = [];
        this.phone = number.e164;
      } else {
        this.phoneErrors = [...this.phoneErrors];
      }
    },
    async register() {
      try {
        this.loading = true;
        const body = {
          email: this.email,
          accountType: [{name: this.accountType}],
          phone_number: this.phone,
        };

        await this.axios.post(`/events/webinar_events/`, body);

        this.$analytics.logEvent("webinar_registration", {
          time: new Date(),
          url: window.location.href,
          version: "frontend version",
        });
        this.$snackbar.showMessage({
          content: "Your have successfully registered for our first webinar",
          color: "success",
        });
        this.phone = '';
        this.accountType = '';
        this.email = '';
        this.$v.$reset();

      } catch (error) {
        this.$snackbar.showMessage({
          content:
            this.constructError(error) ||
            this.$t("errors.somethingWentWrongError"),
          color: "error",
        });
      } finally {
        this.loading = false;
        this.showAddToCalender = true;
      }
    },
    handleAddToCalender() {
      this.$router.push('/webinar-registration')
      const event = " Guiomentor’s First Free Webinar"
      const webinarTimeString = new Date("9/10/2022, 10:00:00 AM")
          .toISOString().replaceAll("-","").replaceAll(":","")
          .replaceAll(".","")
      const webinarTimeStringEnd = new Date("9/10/2022, 2:30:00 PM")
          .toISOString().replaceAll("-","").replaceAll(":","")
          .replaceAll(".","")
      const dates = `${webinarTimeString}/${webinarTimeStringEnd}`
      const details = "Are you a teacher in any grade level or subject? join Guiomentor’s first webinar"
      const url = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${event}&dates=${dates}&details=${details}&location=https://meet.google.com/bpw-onhe-ypm&ctz=Africa/Kampala`
      window.open(url, '_blank').focus();
    },

    constructError(error) {
      if (error.error) return error.error.replace(/_/g, " ");
      let errorMessage = "";
      const errorData = error.response?.data || "";
      if (errorData) {
        if (errorData.detail) {
          errorMessage = errorData.detail;
        } else if (errorData.data?.non_field_errors) {
          const errors = errorData.data.non_field_errors;
          if (errors.length === 1) return (errorMessage = errors[0]);
          errors.forEach((msg, index) => {
            if (index === errors.length - 1) {
              errorMessage += msg;
            }
            errorMessage += msg + ", ";
          });
        }
      }
      return errorMessage;
    },
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email &&
        errors.push(this.$t("auth.forms.errors.emailMustBeValid"));
      !this.$v.email.required &&
        errors.push(this.$t("auth.forms.errors.emailRequired"));
      this.emailTaken &&
        errors.push(this.$t("errors.emailTaken", { email: this.email }));
      return errors;
    },
    accountTypeMessages() {
      const errors = [];
      if (!this.$v.accountType.$dirty) return errors;
      !this.$v.accountType.min &&
        errors.push(this.$t("auth.forms.errors.accountType"));
      return errors;
    },
  },
  validations: {
    email: {
      required,
      email,
    },
    accountType: {
      required,
      min: minLength(1),
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/settings/_variables";

.sign-in-container {
  height: 100vh;

  .row {
    margin: 0;
  }
}

.left {
  background: #0033aa;
  height: 100vh;
  margin-top: 0;
  margin-bottom: 0;

  .logo {
    width: 130px;
    height: 130px;
  }

  .mini-column {
    elevation: higher;
    background: linear-gradient(to right, #b7edeb, #54ded2);
    min-height: 70%;
    max-width: 95%;
    border-radius: 5px;
  }
}

.right {
  background: #f5f6f8;
  height: 100vh;
}

.form {
  background: #ffffff;
  min-height: 450px;
  width: 85%;
  border-radius: 10px;
  padding: 35px;
  box-shadow: 0px 42px 100px rgba(0, 0, 0, 0.12);

  .forgot-password {
    color: rgba(0, 0, 0, 0.6);
  }

  .v-btn {
    text-transform: none !important;
  }

  .login-linked-in {
    background: #0033aa !important;
    color: #ffffff !important;
  }

  .login-twitter {
    background: #2575b3 !important;
    color: #ffffff !important;
  }

  .social-img {
    width: 20px;
    height: 80%;
  }
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .form {
    width: 100% !important;
  }
}
</style>
